import {
  MyInput,
  MySelect,
  MyButton,
  MyModal,
  MyRadio,
  MyCheckBox,
} from "../../../components/Commons";
import { useUserStore } from "../hooks/useUserStore";
import { SYSTEM_ADMIN, TRANSLATOR } from "../../../constants/constants";
import { USER } from "../constants/userText.contants";
import { COMMON } from "../../../constants/commonText.constants";
import { observer } from "mobx-react-lite";
import { COMPANY } from "../../Company/constants/companyText.constants";
import { useCompanyStore } from "../../Company";
import { useTran } from "../../../hooks/useTran";
import { useAuthStore } from "../../Auth";
import { useEffect } from "react";

const CreateUserModal = observer(({ errors }) => {
  const { t } = useTran();

  const {
    roles,
    createUser,
    initialUser,
    getModules,
    _handleChange,
    handleChangeModuleAccess,
    accessToCustom,
    isUserModalOpen,
    closeUserModal,
    selectedCompanyId,
    hideUserModal,
  } = useUserStore();
  const { companyList, openCompanyModal, countryList } = useCompanyStore();
  const { user } = useAuthStore();

  const {
    _id,
    displayName,
    userName,
    email,
    password,
    role,
    companyId,
    isPermitAll,
  } = initialUser;

  useEffect(() => {
    getModules();
  }, []);

  const companyListOption = selectedCompanyId
    ? companyList?.filter((c) => c.key === selectedCompanyId)
    : companyList;
  const roleList =
    user?.role === "reseller"
      ? roles?.filter((u) => u.key === "super_admin")
      : selectedCompanyId
        ? roles?.filter((u) => u.key === "reseller")
        : roles?.filter((u) => u.key !== "super_admin");

  return (
    <MyModal
      isOpen={isUserModalOpen}
      onClose={closeUserModal}
      title={t(_id ? USER.EDIT_USER : USER.CREATE_NEW_USER)}
      size={"medium"}
      isStatic
      footer={
        <div className="flex gap-2 items-center justify-end">
          <MyButton onClick={closeUserModal} variant="outline">
            {t(COMMON.CANCEL)}
          </MyButton>
          <MyButton onClick={() => createUser()} id="createCompanyUser">
            {t(_id ? COMMON.UPDATE : COMMON.CREATE)}
          </MyButton>
        </div>
      }
    >
      <div className="grid grid-cols-2 gap-4 overflow-y-auto">
        <MyInput
          label={t(USER.DISPLAY_NAME)}
          placeholder={t(USER.DISPLAY_NAME)}
          id="displayName"
          value={displayName}
          onChange={_handleChange}
          error={errors.displayName}
        />
        <MyInput
          label={t(USER.USERNAME)}
          placeholder={t(USER.USERNAME)}
          id="userName"
          value={userName}
          onChange={_handleChange}
          error={errors.userName}
        />
        <MyInput
          label={t(USER.EMAIL)}
          placeholder={t(USER.EMAIL)}
          id="email"
          value={email}
          onChange={_handleChange}
          error={errors.email}
        />
        {!_id && (
          <MyInput
            label={t(USER.PASSWORD)}
            placeholder={t(USER.PASSWORD)}
            type="password"
            id="password"
            value={password}
            onChange={_handleChange}
            error={errors.password}
          />
        )}
        <MySelect
          className={`${selectedCompanyId || _id ? "" : "col-span-2"}`}
          label={t(COMMON.ROLE)}
          placeholder={t(USER.SELECT_ROLE)}
          id="role"
          options={roleList}
          value={role}
          onChange={_handleChange}
          error={errors.role}
        />
        {((role !== "" && role !== TRANSLATOR) || selectedCompanyId) && (
          <div
            className={`grid grid-cols-5 flex items-start gap-x-2 ${selectedCompanyId ? "" : "col-span-2"}`}
          >
            <MySelect
              className={`${selectedCompanyId ? "col-span-5" : "col-span-3"}`}
              label={t(COMMON.COMPANY)}
              placeholder={t(USER.SELECT_COMPANY)}
              id="companyId"
              value={selectedCompanyId ?? companyId}
              options={companyListOption}
              onChange={_handleChange}
              error={errors.companyId}
            />
            {!selectedCompanyId && (
              <div className="col-span-2">
                <p>&nbsp;</p>
                <MyButton
                  className="w-full"
                  onClick={() => {
                    hideUserModal();
                    openCompanyModal();
                  }}
                >
                  {t(COMPANY.CREATE_COMPANY)}
                </MyButton>
              </div>
            )}
          </div>
        )}
        {user.role === SYSTEM_ADMIN && (
          <div className="space-y-1 col-span-2">
            <p className="font-medium text-blue-700">
              {t(USER.MODULE_PERMISSIONS)}:
            </p>
            <div className="flex">
              <MyRadio
                id="isPermitAllYes"
                label={t(USER.ACCESS_TO_ALL)}
                checked={isPermitAll}
                onChange={() =>
                  _handleChange({ target: { id: "isPermitAll", value: true } })
                }
              />
              <MyRadio
                id="isPermitAllNo"
                label={t(USER.ACCESS_TO_CUSTOM)}
                checked={isPermitAll == null ? null : !isPermitAll}
                onChange={() =>
                  _handleChange({ target: { id: "isPermitAll", value: false } })
                }
              />
            </div>
          </div>
        )}
        {!isPermitAll && (
          <div className="space-y-1 col-span-2">
            <p className="font-medium text-blue-700">{t(USER.MODULE_LIST)}:</p>
            <ul>
              {accessToCustom?.map((m, mIndex) => {
                return (
                  <li
                    className={`py-1 ${m.moduleName.moduleType?.split("__")[1] === "sub" ? "ms-10" : "mt-4"}`}
                    key={mIndex}
                  >
                    <p
                      className={`${m.moduleName.moduleType?.split("__")[1] === "sub" ? "text-sm" : ""} font-medium text-gray-700`}
                    >
                      {m.moduleName.value}
                    </p>
                    {m.moduleName.moduleType !== "parent" && (
                      <div className="flex text-sm my-2">
                        <MyCheckBox
                          className="ms-5 me-2"
                          checked={m.create}
                          onChange={() =>
                            handleChangeModuleAccess(
                              m.moduleName.key,
                              "create",
                              !m.create,
                            )
                          }
                        />{" "}
                        {USER.CREATE}
                        <MyCheckBox
                          className="ms-5 me-2"
                          checked={m.update}
                          onChange={() =>
                            handleChangeModuleAccess(
                              m.moduleName.key,
                              "update",
                              !m.update,
                            )
                          }
                        />{" "}
                        {USER.UPDATE}
                        <MyCheckBox
                          className="ms-5 me-2"
                          checked={m.view}
                          onChange={() =>
                            handleChangeModuleAccess(
                              m.moduleName.key,
                              "view",
                              !m.view,
                            )
                          }
                        />{" "}
                        {USER.VIEW}
                        <MyCheckBox
                          className="ms-5 me-2"
                          checked={m.drop}
                          onChange={() =>
                            handleChangeModuleAccess(
                              m.moduleName.key,
                              "drop",
                              !m.drop,
                            )
                          }
                        />{" "}
                        {USER.DELETE}
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </MyModal>
  );
});

export default CreateUserModal;
